module.exports = __webpack_public_path__ + "img/Chime2.19f352ab.svg";